/**
 * Duri brand theme — leaf green system used across Header, landing, and UI accents.
 * Prefer these tokens over hardcoded hex in new code.
 */
export const BRAND = {
  primary: "#22C55E",
  primaryDark: "#16A34A",
  primaryDeeper: "#15803D",
  primarySoft: "#ECFDF5",
  primaryMuted: "#DCFCE7",
  primaryBorder: "#BBF7D0",
  ink: "#111827",
  muted: "#6B7280",
} as const;

export type BrandColor = (typeof BRAND)[keyof typeof BRAND];
